/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tld: NonNullable<unknown> }} Tld_Pricing_Costs_SavedInputs */

const id_tld_pricing_costs_saved = /** @type {(inputs: Tld_Pricing_Costs_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Harga ${i?.tld} disimpan.`)
};

const en_tld_pricing_costs_saved = /** @type {(inputs: Tld_Pricing_Costs_SavedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.tld} pricing saved.`)
};

/**
* | output |
* | --- |
* | "{tld} pricing saved." |
*
* @param {Tld_Pricing_Costs_SavedInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_costs_saved = /** @type {((inputs: Tld_Pricing_Costs_SavedInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Costs_SavedInputs, { locale?: "id" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_costs_saved(inputs)
	return id_tld_pricing_costs_saved(inputs)
});